import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'element-plus/dist/index.css';

import App from './App.vue';
import router from './router';
import { registerDirectives } from './directives/permission';
import { reportError } from '@/utils/errorReport';

// 全局未捕获错误上报
window.addEventListener('error', (event) => {
  reportError({
    level: 'error',
    type: 'window_error',
    message: event.message || 'Unknown error',
    stack: event.error?.stack || '',
    url: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : window.location.href,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  reportError({
    level: 'error',
    type: 'unhandledrejection',
    message: reason?.message || String(reason) || 'Unhandled promise rejection',
    stack: reason?.stack || '',
    url: window.location.href,
  });
});

async function bootstrap() {
  const pinia = createPinia();
  const app = createApp(App);
  app.use(pinia);
  app.use(router);

  // Vue 组件错误上报
  app.config.errorHandler = (err, _instance, info) => {
    reportError({
      level: 'error',
      type: 'vue_error',
      message: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack || '' : '',
      url: window.location.href,
      extra: { info },
    });
  };

  // 路由错误上报
  router.onError((err) => {
    reportError({
      level: 'error',
      type: 'router_error',
      message: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack || '' : '',
      url: window.location.href,
    });
  });

  try {
    const { useAuthStore } = await import('@/stores/auth');
    await useAuthStore().fetchMe();
  } catch (e) {
    console.error('[Bootstrap] fetchMe failed', e);
    reportError({
      level: 'error',
      type: 'bootstrap',
      message: e instanceof Error ? e.message : String(e),
      stack: e instanceof Error ? e.stack || '' : '',
      url: window.location.href,
    });
  }

  registerDirectives(app);
  app.mount('#app');
}

bootstrap().catch((err) => {
  console.error('[Bootstrap] fatal', err);
  reportError({
    level: 'error',
    type: 'bootstrap_fatal',
    message: err instanceof Error ? err.message : String(err),
    stack: err instanceof Error ? err.stack || '' : '',
    url: window.location.href,
  });
});
